import { useMutation } from 'react-query';

import { axiosAuthInstance } from '@config/api';
import { ValidateEditUserEmailParams } from '@interfaces/accountSettings';
import { client } from 'app/react-query';
import { QueryKeys } from 'app/react-query/query-keys';

async function validateEditUserEmailService(data: ValidateEditUserEmailParams, token: string) {
  const response = await axiosAuthInstance.put('/users/me/update-mail/verify', data, {
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export function useValidateEditUserEmail(token: string) {
  return useMutation((data: ValidateEditUserEmailParams) => validateEditUserEmailService(data, token), {
    onSuccess: () => {
      client.invalidateQueries(QueryKeys.GET_USER_DATA);
    },
  });
}
